//Import AXIOS
import axios from '../../interceptors';
// Import API URL
import { API_URL } from '../../../../store/urls';
// Import Actions
import { dashboardsActions } from '../../../../store/slices/tools/dashboardsSlice';

export const dashboardsGetStations = () => {
  const accessToken = localStorage.getItem('accessToken');

  return async (dispatchAction) => {
    dispatchAction(dashboardsActions.setIsLoading(true));
    try {
      const response = await axios.get(`${API_URL}/v1/stations/`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const stations = response.data;
      dispatchAction(dashboardsActions.setStations(stations));
    } catch (error) {}
    dispatchAction(dashboardsActions.setIsLoading(false));
  };
};
